import { useNavigate } from "react-router-dom";
import Footer from "./Footer";
import Navbar from "./Navbar";
import { BsWhatsapp } from "react-icons/bs";
import { useEffect, useState } from "react";
import { db } from "./Firebase";

export default function About() {

    const navi = useNavigate();
    const [socialmedia, setsocialmedia] = useState("")

    function fetchData() {
        db.collection("socialmedia").onSnapshot((snapshot) => {
            if (!snapshot.empty) {
                const firstDoc = snapshot.docs[0].data(); // Get the first document's data
                setsocialmedia(firstDoc);
            }
        });
    }
    useEffect(() => {
        fetchData();
    }, [])



    return (
        <>
            <title>About Hack98 | Trusted Wholesale Denims Brand</title>
            <meta name="description" content="Learn about Hack98, a leading wholesale jeans supplier in India. Quality denim, strong partnerships, and premium jeans for men & boys." />
            <meta name="keywords" content="denim manufacturer India, wholesale jeans supplier, denim brand story, men’s jeans manufacturer, wholesale denim company, wholesale jeans supplier, premium denim jeans, men’s jeans wholesale, boys denim wholesale, bulk denim jeans,menswear near me, jeans near me, denims for men, denims for boys near me" />

            <meta property="og:title" content="About Hack98 | Trusted Wholesale Denims Brand" />
            <meta property="og:site_name" content="Hack98" />
            <meta property="og:url" content="https://hack98.club/" />
            <meta property="og:description" content="Learn about Hack98, a leading wholesale jeans supplier in India. Quality denim, strong partnerships, and premium jeans for men & boys." />
            <meta property="og:image" content="logoo.png"></meta>

            <meta name="twitter:card" content="app" />
            <meta name="twitter:site" content="hack98" />
            <meta name="twitter:description" content="Learn about Hack98, a leading wholesale jeans supplier in India. Quality denim, strong partnerships, and premium jeans for men & boys." />
            <meta name="twitter:app:country" content="India" />

            <div className="navbarrrr">
                <Navbar />
            </div>
            <div className="row m-0 justify-content-center align-items-center">

                <section className="mt-5">
                    <div className="container mt-5">
                        <p className="text-center text-primary fw-bold">Discover Who We Are</p>
                        <h1 className="h2 fw-bold text-center mb-3">About Us</h1>
                        <h2 className="small text-center fw-semibold fst-italic mb-4">
                            Crafting a Denim Legacy Since 2014
                        </h2>

                        <div className="row justify-content-center align-items-center">
                            <div className="col-lg-6 mb-4 mb-lg-0 text-center">
                                <img
                                    src="https://italianartisan.com/wp-content/uploads/2024/08/denim-manufacturing.webp"
                                    alt="Hack98 Manufacturing"
                                    className="imgabout"
                                />
                            </div>

                            <div className="col-lg-6">
                                <p>
                                    <strong>Hack98</strong> has been redefining men's fashion since <strong>2014</strong>, offering a premium range of jeans, shorts, and capris designed for the modern Indian man. We blend comfort, durability, and timeless style in every stitch.
                                </p>

                                <p>
                                    What makes us stand out is our unwavering commitment to quality. With our own <strong>cutting-edge manufacturing facility in Delhi</strong>, we maintain total control over craftsmanship, fit, and innovation—ensuring every piece meets our exacting standards.
                                </p>

                                <p>
                                    Whether you're a well-established distributor or an emerging retailer, <strong>Hack98</strong> is your reliable partner for high-quality denim wear — proudly <strong>designed and made in India</strong>.
                                </p>

                                <ul className="list-unstyled mt-4">
                                    <li>🏭 Modern in-house manufacturing unit in Delhi</li>
                                    <li>👖 Premium denim crafted with precision & care</li>
                                    <li><span className="text-success fw-bold me-2">🇮🇳</span>100% Made in India with pride</li>
                                    <li>💼 Trusted by distributors & retailers nationwide</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </section>
                <section className="instagram-gallery py-2 pb-4 bg-light mt-5">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-lg-9 text-center mt-5">
                                <div className="row g-3">
                                    {["images/12.jpg", "images/111.jpg", "images/121.jpg"].map((image, index) => (
                                        <div className="col-4" key={index}>
                                            <div className="insta-img-wrapper rounded overflow-hidden">
                                                <img src={image} alt="Instagram post" className="img-fluid w-100 h-100 object-fit-cover" />
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                <div className="mt-4">
                                    <a href={socialmedia.Instagram} className="btn btn-dark px-4 py-2" target="_blank" rel="noopener noreferrer">
                                        View More on Instagram
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <div className="position-fixed bottom-0 end-0 p-3 z-3">
                {/* <button
                    className="btn btn-primary fixed-join-btn text-light fw-bold px-4 py-2 shadow rounded-pill me-2"
                    onClick={() => navi("/Distributor")}
                >
                    + JOIN NOW
                </button> */}
                <button
                    className="fixed-join-btn text-light fw-bold px-3 py-2 shadow rounded-pill bgcolor"
                    onClick={() =>
                        window.open(
                            "https://wa.me/919517909090?text=Hi%2C%20I%20am%20interested%20in%20your%20products.%20Can%20you%20help%20me%3F",
                            "_blank"
                        )
                    }
                >
                    <BsWhatsapp size={24} />
                </button>
            </div>
            <div className="row m-0 mt-4 align-items-center justify-content-center d-flex flex-wrap p-0 bottom-0 w-100">
                <Footer />
            </div>
        </>
    )
}